import { render, staticRenderFns } from "./BridgeCell.vue?vue&type=template&id=32608b1f"
import script from "./BridgeCell.vue?vue&type=script&lang=js"
export * from "./BridgeCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports